import SoftBadge from 'components/common/SoftBadge';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const CustomerSecondaryBadge = (props) => {
  const {value} = props
  const secondaryContact = value && value.map((name, index) => (
    <SoftBadge bg='info' key={index} className='tw-mr-2'>{name}</SoftBadge>
  ))

  return (
    <Fragment>
      {secondaryContact}
    </Fragment>
  );
};

CustomerSecondaryBadge.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string)
};

export default CustomerSecondaryBadge;
